module.exports = __webpack_public_path__ + "img/Frame 60.0cd1017c.png";